module.exports = __webpack_public_path__ + "img/carpet.78079e34.png";